import { useEffect, useState } from "react";
import { OrganizationService } from "../../../shared/services/organizations/OrganizationService";
import { BrandDateFormat } from "../../../shared/models/brand.model";

/**
 * The brand date formats for the Preferred Date Format select (MPN-2071), read once the page
 * is on them. `failed` disables only that select; the rest of the page doesn't depend on it.
 */
const useBrandDateFormats = (enabled: boolean) => {
    const [formats, setFormats] = useState<BrandDateFormat[]>([]);
    const [isLoading, setIsLoading] = useState(false);
    const [failed, setFailed] = useState(false);

    useEffect(() => {
        if (!enabled) return;
        let current = true;
        setIsLoading(true);
        (async () => {
            try {
                const list = await new OrganizationService().listBrandDateFormats();
                if (!current) return;
                setFormats(list);
                setFailed(false);
            } catch {
                if (current) setFailed(true);
            } finally {
                if (current) setIsLoading(false);
            }
        })();
        return () => {
            current = false;
        };
    }, [enabled]);

    return { formats, isLoading, failed };
};

export default useBrandDateFormats;
